import { apiSlice } from './apiSlice.js';
import { EMAIL_URL } from '../constants.js';

export const emailApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    sendContactEmail: builder.mutation({
      query: (contactData) => ({
        url: EMAIL_URL,
        method: 'POST',
        body: contactData,
      }),
      invalidatesTags: ['Email']
    }),
    sendOrderEmail: builder.mutation({
      query: (orderData) => ({
        url: `${EMAIL_URL}/orderemail`,
        method: 'POST',
        body: orderData,
      }),
      invalidatesTags: ['Email']
    }),
    sendOrderUpdatedEmail: builder.mutation({
      query: (orderData) => ({
        url: `${EMAIL_URL}/orderupdatedemail`,
        method: 'POST',
        body: orderData,
      }),
      invalidatesTags: ['Email']
    }),
    sendOTPEmail: builder.mutation({
      query: ({email}) => ({
        url: `${EMAIL_URL}/sendotp`,
        method: 'POST',
        body: {email},
      }),
      invalidatesTags: ['Email']
    }),
    verifyOTPUpdateEmail: builder.mutation({
      query: ({email, otp}) => ({
        url: `${EMAIL_URL}/verifyotp`,
        method: 'POST',
        body: {email, otp},
      }),
      invalidatesTags: ['Email']
    })
  }),
});

export const {
  useSendContactEmailMutation,
  useSendOrderEmailMutation,
  useSendOrderUpdatedEmailMutation,
  useSendOTPEmailMutation,
  useVerifyOTPUpdateEmailMutation
} = emailApiSlice;